/* eslint-disable */
export default (hotels) => {
    return _.flatten(_.map(hotels
        .pluck('tourProducts'), (tourProducts) => {
        return tourProducts.models;
    }));
};
